import { render, staticRenderFns } from "./_CompareRow.vue?vue&type=template&id=52a21d85"
import script from "./_CompareRow.vue?vue&type=script&lang=js"
export * from "./_CompareRow.vue?vue&type=script&lang=js"
import style0 from "./_CompareRow.vue?vue&type=style&index=0&id=52a21d85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports